import React, { FC } from 'react';

import { useLocale } from '@/shared/hooks/useLocale';

import { formatDate } from '../../lib/date';
import { useI18n } from '../../hooks/useI18n';

import styles from './_ReleaseDate.module.css';

interface ReleaseDateCardProps {
    releaseDate: Date | null;
}

export const ReleaseDate: FC<ReleaseDateCardProps> = ({ releaseDate }) => {
    const i18n = useI18n();
    const locale = useLocale();

    return (
        <div className={styles.rootCard}>
            {!releaseDate ? (
                <div className={styles.releaseLater}>{i18n('episode_card__coming_soon')}</div>
            ) : (
                <>
                    <div className={styles.releaseDay}>{releaseDate.getDate()}</div>
                    <div className={styles.releaseMonth}>
                        {formatDate(releaseDate, locale.lang, { month: 'long' })}
                    </div>
                </>
            )}
        </div>
    );
};
